<template>
    <div class="cockpit-chart">
        <!-- TÍTULO -->
        <div class="chart-title">
            {{ title }}
        </div>

        <!-- CONTEÚDO -->
        <div ref="chartContent" class="chart-content long-text-content scroll" v-if="!noData">
            <div class="long-text-wrapper">
                <div class="long-text" v-for="(d, i) in datacontent" :key="i">
                    {{ d.label }}
                </div>
            </div>
        </div>

        <!-- FOOTER -->
        <div class="chart-footer long-text-footer" v-if="!noData"></div>

        <!-- MSG NÃO HÁ DADOS -->
        <div class="chart-no-text" v-if="noData">
            <svg class="fail">
                <use :xlink:href="require('@/assets/img/icons/chart-error.svg') + '#layer'"></use>
            </svg>
            <div>{{ $t('chart-no-data') }}</div>
        </div>
    </div>
</template>

<script>
import CockpitChart from '@/components/shared/chart/CockpitChart';
import paleta from '@/functions/color/paleta.js';

export default {
    extends: CockpitChart,
    props: ['title', 'datacontent'],
    data() {
        return {
            noData: false,
        };
    },
    created() {
        if (!this.datacontent) {
            this.noData = true;
        }
    },
    methods: {},
    computed: {
        svgResultStyle() {
            return {
                fill: this.datacontent.positivo ? paleta.colors.green : paleta.colors.red,
            };
        },
        resultStyle() {
            return {
                color: this.datacontent.positivo ? paleta.colors.green : paleta.colors.red,
            };
        },
    },
};
</script>

<style lang="scss">
.scroll {
    overflow-y: scroll;
}
</style>
